/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig = {
    // dev
    auth: {
        clientId: process.env.REACT_APP_CLIENTID,
        // authority: "https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51",
        authority: process.env.REACT_APP_AUTHORITY,
        knownAuthorities: [process.env.REACT_APP_KNOWNAUTHORITIES],
        redirectUri: process.env.REACT_APP_REDIRECTURI,
        responseType: ["id_token", "token"]
    },
    // test
    // auth: {
    //     clientId: "f421594b-f599-4cfb-ba1e-8ecfa55506c1",
    //     // authority: "https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51",
    //     authority: "https://tcareheavyind.b2clogin.com/tcareheavyind.onmicrosoft.com/B2C_1A_SMART_HRD_SUSI",
    //     knownAuthorities: ["tcareheavyind.b2clogin.com"],
    //     // redirectUri: "https://dev.tcare.ai",
    //     redirectUri: "http://localhost:3000",
    //     responseType: ["id_token", "token"]
    // },
    // test
    // auth: {
    //     clientId: "7dd0bde8-2dd3-44f7-8320-15cef4ea0222",
    //     // authority: "https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51",
    //     authority: "https://tcaretestb2c.b2clogin.com/tcaretestb2c.onmicrosoft.com/B2C_1A_SMART_HRD_SUSI",
    //     knownAuthorities: ["tcaretestb2c.b2clogin.com"],
    //     // redirectUri: "https://tcetest.tcare.ai",
    //     redirectUri: "http://localhost:3000",
    //     responseType: ["id_token", "token"]
    // },
    //UAT
    // auth: {
    //     clientId: "b3b37717-1c22-40ca-b389-c42917a1b0ab",
    //     // authority: "https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51",
    //     authority: "https://tcaretestb2c.b2clogin.com/tcaretestb2c.onmicrosoft.com/B2C_1A_SMART_HRD_SUSI",
    //     knownAuthorities: ["tcaretestb2c.b2clogin.com"],
    //     // redirectUri: "https://tcetest.tcare.ai",
    //     redirectUri: "http://localhost:3000",
    //     responseType: ["id_token", "token"]
    // },
    //Sandbox
    // auth: {
    //     clientId: "a9628489-b2fd-4b88-a4df-a7fad7d43f4d",
    //     // authority: "https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51",
    //     authority: "https://tcaretestb2c.b2clogin.com/tcaretestb2c.onmicrosoft.com/B2C_1A_SMART_HRD_SUSI",
    //     knownAuthorities: ["tcaretestb2c.b2clogin.com"],
    //     // redirectUri: "https://tcetest.tcare.ai",
    //     redirectUri: "http://localhost:3000",
    //     responseType: ["id_token", "token"]
    // },
    // prod
    // auth: {
    //     clientId: "b3638df0-5201-4f5e-92e1-3ce8ef4002b4",
    //     // authority: "https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51",
    //     authority: "https://tcareai.b2clogin.com/tcareai.onmicrosoft.com/B2C_1A_SMART_HRD_SUSI",
    //     knownAuthorities: ["tcareai.b2clogin.com"],
    //     redirectUri: "https://molina.tcare.ai",
    //     // redirectUri: "http://localhost:3000",
    //     responseType: ["id_token", "token"]
    // },
    // prod
    // auth: {
    //     clientId: "b3638df0-5201-4f5e-92e1-3ce8ef4002b4",
    //     // authority: "https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51",
    //     authority: "https://tcareai.b2clogin.com/tcareai.onmicrosoft.com/B2C_1A_SMART_HRD_SUSI",
    //     knownAuthorities: ["tcareai.b2clogin.com"],
    //     redirectUri: "https://molina.tcare.ai",
    //     // redirectUri: "http://localhost:3000",
    //     responseType: ["id_token", "token"]
    // },
    // anthem
    // auth: {
    //     clientId: "9cc875c2-955c-4e7a-be34-3ca0b726dc63",
    //     // authority: "https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51",
    //     authority: "https://tcareai.b2clogin.com/tcareai.onmicrosoft.com/B2C_1A_SMART_HRD_SUSI",
    //     knownAuthorities: ["tcareai.b2clogin.com"],
    //     redirectUri: "https://anthem.tcare.ai",
    //     // redirectUri: "http://localhost:3000",
    //     responseType: ["id_token", "token"]
    // },
    // tceprod
    // auth: {
    //     clientId: "b2292d07-298f-4d3e-b1fe-f549d56a0408",
    //     // authority: "https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51",
    //     authority: "https://tcareai.b2clogin.com/tcareai.onmicrosoft.com//B2C_1A_SMART_HRD_SUSI",
    //     knownAuthorities: ["tcareai.b2clogin.com"],
    //     redirectUri: "https://app.tcare.ai",
    //     // redirectUri: "http://localhost:3000",
    //     responseType: ["id_token", "token"]
    // },
     // Prudentials
    //  auth: {
    //     clientId: "2e4f0a9e-83b8-40b0-86d9-30be7168c988",
    //     // authority: "https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51",
    //     authority: "https://tcareai.b2clogin.com/tcareai.onmicrosoft.com//B2C_1A_SMART_HRD_SUSI",
    //     knownAuthorities: ["tcareai.b2clogin.com"],
    //     redirectUri: "https://prudential.tcare.ai",
    //     // redirectUri: "http://localhost:3000",
    //     responseType: ["id_token", "token"]
    // },
    // Cigna
    //   auth: {
    //     clientId: "27624f23-a5cf-492c-8158-9e7fd5e6e7ec",
    //     // authority: "https://login.microsoftonline.com/0ec4d3be-d7e7-4167-8cb9-688ce1f08d51",
    //     authority: "https://tcareai.b2clogin.com/tcareai.onmicrosoft.com//B2C_1A_SMART_HRD_SUSI",
    //     knownAuthorities: ["tcareai.b2clogin.com"],
    //     redirectUri: "https://cigna.tcare.ai",
    //     // redirectUri: "http://localhost:3000",
    //     responseType: ["id_token", "token"]
    // },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;	
                    default:    
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["openid", process.env.REACT_APP_SCOPE]
    //UAT
    // scopes: ["openid", "https://tcaretestb2c.onmicrosoft.com/ad0745e6-63da-4f48-92fb-29762c2e2ee3/TCARE5.User"]
    //Molina
    // scopes: ["openid", "https://tcareai.onmicrosoft.com/TCARE5-Molina/TCARE5.User"]
    //Sandbox
    // scopes: ["openid", "https://tcareai.onmicrosoft.com/TCARE5_Sandbox/TCARE5.User"]
    // Anthem
    // scopes: ["openid", "https://tcareai.onmicrosoft.com/TCARE5-Anthem/TCARE5.User"]
     // TceProd
    // scopes: ["openid", "https://tcareai.onmicrosoft.com/TCARE5-Enterprise/TCARE5.User"]
     // Prudential
    //  scopes: ["openid", "https://tcareai.onmicrosoft.com/TCARE5-Prudential/TCARE5.User"]
    // Cigna
    // scopes: ["openid", "https://tcareai.onmicrosoft.com/TCARE5-Cigna/TCARE5.User"]
};



/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me"
};
